export default __webpack_public_path__ + "static/media/blog-post-03.48ca2014.jpg";